import React from 'react'
import styled from 'styled-components'
import {getPlaceHolderImage} from '../../../utils/helpers'
import PropTypes from 'prop-types'

// TODO: Move to components folder...
const getBackgroundUrl = ({url, imageType}) => {
  return url ? `url(${url})` : `url(${getPlaceHolderImage(imageType)})`
}

const Image = ({url, imageType, placeholder, style}) => {
  const backgroundImage = getBackgroundUrl({url, imageType})

  // Display the image if the URL is populated or the placeholder prop is true.
  return url || placeholder ? (
    <ImageContainer
      imageType={imageType}
      backgroundImage={backgroundImage}
      style={style}
    />
  ) : null
}

Image.propTypes = {
  /* URL of the image file */
  url: PropTypes.string,

  /* Displays the placeholder image when true and the url is empty */
  placeholder: PropTypes.bool.isRequired
}

Image.defaultProps = {
  imageType: 'building',
  placeholder: true
}
export default Image

const ImageContainer = styled.div`
  width: ${props => (props.imageType === 'employee' ? '165px' : '100%')};
  height: ${props => (props.imageType === 'employee' ? '165px' : '100%')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: ${props => (props.imageType === 'employee' ? '200px' : '0')};
  background-image: ${props => props.backgroundImage};

  @media (max-width: 1024px) {
    width: ${props => (props.imageType === 'employee' ? '145px' : '100%')};
    height: ${props => (props.imageType === 'employee' ? '145px' : '100%')};
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
`
